/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { Component, OnInit, ChangeDetectionStrategy, ViewChild, ViewContainerRef } from '@angular/core';

@Component({
	selector: 'popup-wrapper',
	templateUrl: './popup-wrapper.component.html',
	styles: [],
	changeDetection: ChangeDetectionStrategy.OnPush,
	host: { class: 'popup-wrapper-new--blocker popup-wrapper-new' },
})
export class PopupWrapperComponent implements OnInit {
	@ViewChild('insertion', { static: true, read: ViewContainerRef }) public insertion: ViewContainerRef;

	constructor() {}

	public ngOnInit() {}
}
